<!-- goods-detail 商品详情 -->

<template>
  <div class="goods-detail-page budo-2">
    <PageBack />

    <div class="content-box">
      <div class="box1">
        <van-swipe @change="onChange" class="my-swipe">
          <van-swipe-item v-for="(item, index) of images" :key="index"
            style="text-align: center;background-color: #fff;">
            <van-image :src="item" fit="contain"
              style="position:absolute;top:0;left:0;right:0;bottom:0;margin: 0 auto;">
            </van-image>
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">
              {{ current + 1 }}/{{ images ? images.length : 0 }}
            </div>
          </template>
        </van-swipe>
      </div>
      <div class="box2">
        <div class="goods-price flex-row row-between col-center">
          <div v-if="goodsDetail.onlyTimesCard !== 1" class="flex-row col-end">
            <div style="font-size: 21px; font-weight: bold; color: #fc3f3f">
              {{ goodsDetail.price | money }}
            </div>
            <div class="ml4" style="
                font-size: 12px;
                font-weight: 500;
                text-decoration: line-through;
                color: #9a9a9b;
                margin-bottom: 3px;">
              {{ (goodsDetail.originalPrice > 0 ? goodsDetail.originalPrice : '') | money(true) }}
            </div>
          </div>
        </div>
        <div class="goods-name">
          <van-tag v-for="tag in goodsDetail.tags" :key="tag" color="#f55519" size="medium"
            style="display: block;float: left;margin-top: 6px;margin-right: 4px;">{{ tag }}
          </van-tag>
          &nbsp;{{ goodsDetail.name }}
        </div>
      </div>
      <div v-if="goodsDetail.adsTitle" class="box3 mt5">
        <div class="text-box flex-row col-center" style="height: 100%" v-html="goodsDetail.adsTitle"></div>
      </div>
      <div v-if="goodsDetail.goodsType !== 'HEALTH'" class="box4 mt5 flex-col row-between">
        <div v-if="multipleSpec" class="flex-row col-center">
          <div style="flex: 3">已选</div>
          <div class="flex-row row-between" style="flex: 20">
            <div>
              {{ specValue.join(",") }}
              <goods-spec ref="spec" :cate-code="goodsDetail.cateCode" :goods-id="goodsDetail.goodsId"
                :head-image="goodsDetail.headImage" :name="goodsDetail.name" :price="goodsDetail.price"
                :spec="goodsDetail.spec" :spec-visible="visibleSpecWin" @spchange="specValueChange">
              </goods-spec>
            </div>
            <van-icon v-if="multipleSpec" name="arrow" @click="showSpec" />
          </div>
        </div>

        <div v-if="visibleBrandShop" class="flex-row col-center h30">
          <div style="flex: 3">门店</div>
          <div class="flex-row row-between" style="flex: 20" @click="showShopList(goodsDetail.brandId)">
            <div style="color: #999">当前城市适用门店</div>
            <van-icon name="arrow" />
          </div>
        </div>

        <van-popup v-model="brandShopVisible" :style="{ height: '60%' }" closeable position="bottom" round>
          <van-row>
            <van-col span="24">
              <div class="van-hairline--bottom" style="padding: 16px;line-height: 25px">
                <span style="font-size: 24px;">{{ $store.getters.city_name }}</span>
              </div>
            </van-col>
          </van-row>
          <van-row justify="center" type="flex">
            <van-col span="6" style="background-color: #f7f8fa;">
              <van-sidebar v-model="brandShopRegion" style="width: 100%;" @change="brandShopOnChange">
                <van-sidebar-item v-for="r in brandShopList" :key="r.region">
                  <template #title>
                    {{ r.region }} &nbsp;<span style="color: #999">{{ r.count }}</span>
                  </template>
                </van-sidebar-item>
              </van-sidebar>
            </van-col>
            <van-col span="18" style="padding: 16px">
              <div v-for="r in selectedBrandShopList" :key="r.name" class="shop-info">
                <span class="title">{{ r.name }}</span>
                <span class="content"><van-icon color="#999" name="phone-o" />&nbsp;{{ r.mobile }}</span>
                <span class="content"><van-icon color="#999" name="location-o" />&nbsp;{{ r.address }}</span>
                <span class="content"><van-icon color="#999" name="clock-o" />&nbsp;{{ r.openTime }}</span>
              </div>
            </van-col>
          </van-row>
        </van-popup>

        <div class="flex-row col-center  h30">
          <div style="flex: 3">地址</div>
          <div class="flex-row row-between" style="flex: 20">
            <div>{{ address ? address.address : '' }}</div>
            <router-link to="/user-center-address">
              <van-icon name="arrow" />
            </router-link>
          </div>
        </div>
        <div class="flex-row col-center  h30">
          <div style="flex: 3">运费</div>
          <div class="flex-row row-between" style="flex: 20">
            <div>{{ expressName }}</div>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>

      <div v-if="goodsDetail.brandId > 0" class="box5 mt10">
        <div class="flex-row">
          <img :src="brand.headImage" alt="" class="shop-head" />
          <div class="flex-row row-between" style="width: 296px">
            <div class="ml4">
              <div style="font-size: 12px; font-weight: 500; color: #0a0a0a">
                {{ brand.name }}
              </div>
              <div class="mt6" style="font-size: 9px; font-weight: 500; color: #666666">
                {{ brand.detail }}
              </div>
            </div>
            <div class="flex-row" style="height: 100%">
              <div class="shop-btn">
                <router-link :to="{ path: 'brand-detail', query: { brandId: brand.brandId, cateId: cateId } }"
                  style="color: #fff">
                  进入品牌
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="mt14">
          <div style="font-size: 14px; font-weight: 500; color: #131313">
            商品推荐
          </div>

          <div class="mt8 flex-row row-between" style="overflow-y: auto">
            <div v-for="item of recommend" :key="item.goodsId" class="goods-item">
              <goods-unit :goods-id="item.goodsId" :goods-style="2" :goods-type="item.goodsType"
                :head-image="item.headImage" :name="item.name" :price="item.price" :sale-count="item.sale"
                :spec="item.spec"></goods-unit>
            </div>
          </div>
        </div>
      </div>

      <div style="background-color: #fff">
        <p>
          <img v-for="(item, index) in goodsDetail.detail" :key="index" :src="item" alt=""
            style="margin: 0;padding: 0;vertical-align: bottom;" width="100%" />
        </p>
        <div style="padding: 15px">
          <div class="rich-text" v-html="goodsDetail.notice"></div>
        </div>
        <gas-map v-if="goodsDetail.supplierId === 150"></gas-map>
      </div>

      <div class="box6 flex-row">
        <div style="
            display: flex;
            flex-direction: column;
            align-items: stretch;
            justify-content: center;
            width: 100%;
            font-size: 10px;
            background-color: #fff;">

          <div class="van-sku-actions">
            <van-goods-action-icon v-if="goodsDetail.isAddCard && goodsCount > 0" :badge="goodsCount" icon="cart-o"
              text="购物车" @click="v6_go_cart" />

            <van-goods-action-icon v-if="goodsDetail.isAddCard && goodsCount < 1" icon="cart-o" text="购物车"
              @click="v6_go_cart" />

            <van-button v-if="goodsDetail.isAddCard" color="linear-gradient(to right,#ffd01e,#ff8917)" round
              size="large" type="warning" @click="addCart">加入购物车</van-button>

            <van-button :color="btn_color()" round size="large" type="danger" @click="toBuy">
              <span v-if="goodsDetail.onlyTimesCard === 1">立即兑换</span>
              <span v-else>立即购买</span>
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getBrandById,
  getExpressById,
  api_get_goods_by_id,
  api_get_goods_list_by_params,
  getGoodsStockById,
  getJdVopGoodsStock,
} from "@/api/goods-api";
import GoodsSpec from "@/components/common/goods-spec";
import GoodsUnit from "@/components/common/goods-unit";
import { Toast, Dialog } from "vant";
import { mall_util_order_buy_goods } from "@/util/orders";
import { GOODS_TYPE_GENERAL_GOODS } from "@/api/constant";
import { getBrandShopListById } from "@/api/sys-api";
import GasMap from "@/components/common/gas-map";

export default {
  name: "index",
  components: { GasMap, GoodsSpec, GoodsUnit },
  data() {
    return {
      visibleSpecWin: false,
      goodsId: 0,
      current: 0,
      recommend: [],
      goodsDetail: {},
      // address: this.$store.getters.address,
      images: [],
      multipleSpec: false,
      specValue: [],
      expressName: "",
      brand: {},
      cateId: this.get_mall_module_topCateId(),
      brandShopVisible: false,
      brandShopRegion: 0,
      brandShopList: [],
      selectedBrandShopList: [],
      visibleBrandShop: false,
      topicId: 0
    };
  },

  computed: {
    goodsCount: function () {
      const cart = this.$store.getters.cart;
      if (cart && Array.isArray(cart) && cart.length > 0) {
        return cart.length;
      }
      return 0;
    },

    goodsStock: function () {
      return this.goodsDetail.stock;
    },

    address: function () {
      return this.$store.getters.address;
    }
  },

  created() {
    this.goodsId = this.$route.query.goodsId || 0;
    this.topicId = this.$route.query.topicId || 0;
    this.getGoodsInfo();
    // window.location.reload();
  },

  methods: {
    btn_color() {
      // budo_log.info("#275 btn_color by 库存", this.goodsDetail);

      if (this.goodsDetail && this.goodsDetail.stock && this.goodsDetail.stock > 0) {
        return "linear-gradient(to right, #ff6034, #ee0a24)";
      }

      return "linear-gradient(to left, #ff6034, #ee0a24)";
    },

    v6_go_cart() {
      this.$router.push('/cart')
    },

    isAddCard(res) {
      if (res.data.supplierId == 321 || res.data.supplierId == 337) {
        return false // 蛋糕叔叔 海威直充
      }

      return res.data.goodsType === GOODS_TYPE_GENERAL_GOODS && res.data.onlyTimesCard === 0
    },

    getGoodsInfo() {
      api_get_goods_by_id(this.goodsId).then(res => {
        budo_log.debug("#306 getGoodsInfo api_get_goods_by_id", res);

        // 产品信息不对
        if (res.code && res.code > 0) {
          Dialog.alert({ message: res.msg || "产品信息异常" })
          return
        }

        // 正常渲染流程
        this.goodsDetail = {
          ...res.data,
          isAddCard: this.isAddCard(res)
        };

        this.images = res.data.images;

        // 商品扩展参数
        sessionStorage.setItem("bms.goods_detail_params", res.data.params);
        sessionStorage.setItem("bms.goods_detail_sn", res.data.sn);

        // {"specValueList":[],"specList":[{"specId":1,"selectedValues":[],"values":[],"name":"场次"}]}
        if (res.data.spec) {
          const spec = JSON.parse(res.data.spec);
          this.multipleSpec = true;
          this.specValue = spec.specValueList && spec.specValueList.length > 0
            ? spec.specValueList[0].sp
            : [];
        }

        // 注意可能有客户邮费不同的情况 但这里似乎只展示名字
        if (res.data.expressId > 0) {
          getExpressById(res.data.expressId).then((exp) => {
            this.expressName = exp.data.name;
          });
        }

        if (res.data.brandId > 0) {
          getBrandById(res.data.brandId).then((brand) => {
            this.brand = brand?.data;
          });

          getBrandShopListById(res.data.brandId).then(res => {
            Object.keys(res.data).length > 0 ? this.visibleBrandShop = true : '';
          })

          api_get_goods_list_by_params({
            regionCode: this.$store.getters.city_code,
            brandId: res.data.brandId,
            cateId: this.cateId
          }).then((goodsRes) => {
            this.recommend = goodsRes.data.records;
          });
        }

        this.$store.dispatch("GetDefaultAddress").then(() => {
          const jd_supplier_id = 157;
          const vop_supplier_id = 186;
          const add = this.$store.getters.address;
          if (add && add.addressId && add.addressId > 0) {
            if (res.data.supplierId === jd_supplier_id) {
              getGoodsStockById(this.goodsId, 1, add.addressId).then(res2 => {
                if (res2.code === 0 && parseInt(res2.data) === 1) {
                  this.goodsDetail.stock = 1;
                } else {
                  this.goodsDetail.stock = 0;
                }
              });
            } else if (res.data.supplierId === vop_supplier_id) {
              getJdVopGoodsStock(this.goodsId, 1, add.addressId).then(res2 => {
                if (res2.code === 0 && parseInt(res2.data) === 1) {
                  this.goodsDetail.stock = 1;
                } else {
                  this.goodsDetail.stock = 0;
                }
              });
            }
          } else if (res.data.supplierId === jd_supplier_id || res.data.supplierId === vop_supplier_id) {
            Toast.fail({ duration: 3000, message: '请设置收货地址查询库存' });
          }
        })
      })
    },

    addCart() {
      if (this.multipleSpec) {
        this.showSpec()
      } else {
        mall_util_order_buy_goods(this.goodsDetail.goodsId, 1, true)
      }
    },

    toBuy() {
      Toast("去购买 ..")

      if (this.multipleSpec) {
        this.showSpec()
      } else {
        mall_util_order_buy_goods(this.goodsDetail.goodsId, 1, false, null, 0, this.topicId)
      }
    },

    onChange(index) {
      this.current = index;
    },

    showSpec() {
      this.visibleSpecWin = true
      this.$refs.spec.initSpecInfo(this.goodsDetail.isAddCard)
    },

    specValueChange(value) {
      this.specValue = value.selectedSkuComb.id;
    },

    showShopList(brandId) {
      this.brandShopVisible = true;
      this.brandShopList = [];
      getBrandShopListById(brandId).then(res => {
        let index = 1;
        let allShopList = [];

        for (const data in res.data) {
          allShopList = [...allShopList, ...res.data[data]];
        }

        budo_log.info("#451", allShopList)

        this.brandShopList.push({
          index: 0,
          region: '全部',
          count: allShopList.length,
          list: allShopList
        })

        for (const key in res.data) {
          this.brandShopList.push({
            index: index,
            region: key,
            count: res.data[key].length,
            list: res.data[key]
          })
          index++;
        }

        this.brandShopOnChange(0);
      })
    },

    brandShopOnChange(index) {
      budo_log.info("#474 brandShopOnChange", index)
      this.selectedBrandShopList = this.brandShopList.find(s => s.index === index).list;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "index";

.my-swipe {
  height: 350px;
}

.my-swipe .van-swipe-item {
  line-height: 350px;
  height: 350px;
  text-align: center;
  position: relative;
}

::v-deep .health-detail {
  line-height: 18px;
}

.goods-stock {
  float: left;
  width: 300px;
  z-index: 999;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
</style>
